import React, { useContext } from 'react'

// ui-kit
import { Row, Col } from '@navent-jobs/ui-kit/components/grid'
import Text from '@navent-jobs/ui-kit/components/text'
import { ThemeContext } from 'styled-components'
import { InformationBox, InformationList, InformationItem, InformationlIcon } from './mixins'

const conocimientoNivel = { 13: 'No aplica' }

const RowCustom = ({ conocimientos }) => {
  const { colors } = useContext<{ colors }>(ThemeContext)

  if (!conocimientos || conocimientos.length <= 0) {
    return null
  }

  const conocimientosCustom = conocimientos
  const itemsPerRow = 3
  const totalRows = Math.ceil(conocimientosCustom.length / itemsPerRow)
  const rows: any[] = []

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < totalRows; i++) {
    conocimientosCustom[i].id = i
    rows.push(conocimientosCustom.slice(i * itemsPerRow, i * itemsPerRow + itemsPerRow))
  }

  return rows
    .map(row => {
      return (
        <Row key={`row-skills-${row}`}>
          {row.map(item => {
            return (
              <Col key={`column-skills-${item.id}`} lg={4}>
                <InformationList>
                  <InformationItem>
                    <InformationlIcon
                      name="icon-light-arrow-triangle-right"
                      color={colors.secondary.normal}
                      size="20"
                    />
                    <Text size="md" variant="gray60">
                      {item.conocimientoEspecifico.nombre}
                      {conocimientoNivel[item.nivel.id] !== 'No aplica' ? ' - '.concat(item.nivel.nombre) : ''}
                    </Text>
                  </InformationItem>
                </InformationList>
              </Col>
            )
          })}
        </Row>
      )
    })
    .flat()
}

const Skills = ({ conocimientos }) => {
  return (
    <InformationBox>
      <Text size="sm" fontWeight="semibold" variant="primary" as="h5">
        Conocimientos y habilidades valorados
      </Text>
      {RowCustom({ conocimientos })}
    </InformationBox>
  )
}

export default Skills
